  import { STATUS_LABEL } from '../../utils/memberStatus';

  // Status cards (Active … Ghost) take their titles from memberStatus.js; api/user.js
  // fetchUsersData switches on the same STATUS_LABEL values, so the two stay in sync.
  export const userCardData = [
  {
    title: 'Registered Users',
    maleCount: 9000,
    femaleCount: 6000,
    otherCount: 500,
    color: '#3498db',
    showIcon: true,
  },
  {
    title: STATUS_LABEL.active,
    maleCount: 4521,
    femaleCount: 4571236,
    otherCount: 300,
    color: 'var(--success-600)',
    showIcon: true,
  },
      {
    title: STATUS_LABEL.approved,
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 5,
    color: '#2ecc71',
    showIcon: false,
  },
      {
    title: STATUS_LABEL.hidden,
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 5,
    color: '#2ecc71',
    showIcon: false,
  },
    {
    title: STATUS_LABEL.inactive,
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 5,
    color: '#2ecc71',
    showIcon: false,
  },
    {
    title: STATUS_LABEL.ghost,
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 5,
    color: '#2ecc71',
    showIcon: false,
  },
    {
    // title: `<div class="d-flex gap-2 align-items-center"><img src="/assets/images/admin-panel/verified-icon.svg" className="img-fluid" alt="Verified" /> Verified</div>`,
    title: `Verified`,
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 50,
    color: '#e67e22',
    showIcon: false,
  },
  {
    title: 'De-activated users',
    maleCount: 14,
    femaleCount: 11,
    otherCount: 2,
    color: 'var(--danger-400)',
    showIcon: true,
  },
  {
    title: 'Suspended User',
    maleCount: 0,
    femaleCount: 0,
    otherCount: 0,
    color: 'var(--danger-400)',
    showIcon: true,
  }, // No icon
  {
    title: 'Permanently deleted',
    value: 0,
    color: '#2ecc71',
    showIcon: false,
  },

  {
    title: 'Subscribed',
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 30,
    color: '#2ecc71',
    showIcon: false,
  },
  {
    title: 'Average Age',
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 20,
    color: '#2ecc71',
    showIcon: false,
  },
  {
    title: 'Blocked Profile',
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 10,
    color: '#2ecc71',
    showIcon: false,
  },
  {
    title: 'Flag/Report',
    maleCount: 1000,
    femaleCount: 800,
    otherCount: 5,
    color: '#2ecc71',
    showIcon: false,
  },
  {
    title: 'Device',
    value: '14',
    color: '#2ecc71',
    showIcon: false,
    count: []
  },
  // { title: 'Country', value: '14', color: '#34495e', showIcon: false }, // No icon
];
